/**
 * React Native Web Compatibility Fix for SDK 51
 * Fixes createContext and other React compatibility issues
 */

import React from 'react';

// Ensure React.createContext is properly available
if (typeof React.createContext === 'undefined') {
  // Polyfill createContext if it's missing
  (React as any).createContext = function<T>(defaultValue: T) {
    const context = {
      Provider: ({ children, value }: { children: React.ReactNode; value: T }) => children,
      Consumer: ({ children }: { children: (value: T) => React.ReactNode }) => children(defaultValue),
      displayName: 'Context',
      _currentValue: defaultValue,
      _currentValue2: defaultValue,
      _threadCount: 0,
    };
    return context;
  };
}

// Fix for useLocale hook issues
export function fixReactNativeWebContext() {
  // Ensure React context functions are available
  if (typeof window !== 'undefined') {
    // Make sure React is globally available
    (window as any).React = React;
    
    // Fix for createContext issues
    if (React.createContext) {
      const originalCreateContext = React.createContext;
      React.createContext = function<T>(defaultValue: T) {
        try {
          return originalCreateContext(defaultValue);
        } catch (error) {
          console.warn('React.createContext fallback used:', error);
          // Fallback implementation
          return {
            Provider: ({ children, value }: { children: React.ReactNode; value: T }) => 
              React.createElement(React.Fragment, {}, children),
            Consumer: ({ children }: { children: (value: T) => React.ReactNode }) => 
              React.createElement(React.Fragment, {}, children(defaultValue)),
            displayName: 'Context',
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            _threadCount: 0,
          } as any;
        }
      };
    }
  }
}

// Apply the fix immediately
fixReactNativeWebContext();

export default fixReactNativeWebContext;